export const locales = {
  "en-US": { vstFormat: "en", label: "English", vstuiFormat: "en" },
  "ar-SA": { vstFormat: "ar", label: "العربية", vstuiFormat: "ar" },
  "bg-BG": { vstFormat: "bg", label: "Български", vstuiFormat: "bg" },
  "ca-ES": { vstFormat: "ca", label: "Català", vstuiFormat: "ca" },
  "cs-CZ": { vstFormat: "cs", label: "čeština", vstuiFormat: "cs" },
  "cy-GB": { vstFormat: "cy", label: "Cymraeg", vstuiFormat: "cy" },
  "da-DK": { vstFormat: "da", label: "Dansk", vstuiFormat: "da" },
  "de-DE": { vstFormat: "de", label: "Deutsch", vstuiFormat: "de" },
  "el-GR": { vstFormat: "el", label: "ελληνικά", vstuiFormat: "el" },
  "en-GB": {
    vstFormat: "en_GB",
    label: "English (UK)",
    vstuiFormat: "en-GB",
  },
  "es-ES": { vstFormat: "es", label: "Español", vstuiFormat: "es" },
  "es-MX": {
    vstFormat: "es_MX",
    label: "Español - México",
    vstuiFormat: "es-MX",
  },
  "fi-FI": { vstFormat: "fi", label: "Suomi", vstuiFormat: "fi" },
  "tl-PH": { vstFormat: "fil", label: "Tagalog", vstuiFormat: "tl" },
  "fr-CA": {
    vstFormat: "fr_CA",
    label: "Français - Canada",
    vstuiFormat: "fr-CA",
  },
  "fr-FR": { vstFormat: "fr", label: "Français", vstuiFormat: "fr" },
  "ga-IE": { vstFormat: "ga", label: "Gaeilge", vstuiFormat: "ga" },
  "he-IL": { vstFormat: "he", label: "עברית", vstuiFormat: "he" },
  "hi-IN": { vstFormat: "hi", label: "हिंदी", vstuiFormat: "hi" },
  "hu-HU": { vstFormat: "hu", label: "Magyar", vstuiFormat: "hu" },
  "is-IS": { vstFormat: "is", label: "Íslenska", vstuiFormat: "is" },
  "it-IT": { vstFormat: "it", label: "Italiano", vstuiFormat: "it" },
  "ja-JP": { vstFormat: "ja", label: "日本語", vstuiFormat: "ja" },
  "ko-KR": { vstFormat: "ko", label: "한국어", vstuiFormat: "ko" },
  "nl-NL": { vstFormat: "nl", label: "Nederlands", vstuiFormat: "nl" },
  "nb-NO": { vstFormat: "no", label: "Norsk", vstuiFormat: "nb" },
  "pl-PL": { vstFormat: "pl", label: "Polskie", vstuiFormat: "pl" },
  "pt-BR": {
    vstFormat: "pt_BR",
    label: "Português do Brasil",
    vstuiFormat: "pt-BR",
  },
  "pt-PT": { vstFormat: "pt", label: "Português", vstuiFormat: "pt" },
  "ro-RO": { vstFormat: "ro", label: "Română", vstuiFormat: "ro" },
  "ru-RU": { vstFormat: "ru", label: "Pусский", vstuiFormat: "ru" },
  "sv-SE": { vstFormat: "sv", label: "Svensk", vstuiFormat: "sv" },
  "th-TH": { vstFormat: "th", label: "ภาษาไทย", vstuiFormat: "th" },
  "tr-TR": { vstFormat: "tr", label: "Türkçe", vstuiFormat: "tr" },
  "vi-VN": { vstFormat: "vi", label: "Tiếng Việt", vstuiFormat: "vi" },
  "zh-CN": {
    vstFormat: "zh_CN",
    label: "中文简体",
    vstuiFormat: "zh-CN",
  },
  "zh-TW": {
    vstFormat: "zh_TW",
    label: "繁體中文",
    vstuiFormat: "zh-TW",
  },
};

export const isSupported = (fullLocale) => {
  return !!locales[fullLocale];
};

export const getFullLocaleFromVst = (vstLocale: string) => {
  return Object.entries(locales).find(([k, v]) => {
    return v.vstFormat === vstLocale;
  })?.[0];
};

export const getVstFromFullLocale = (fullLocale: string) => {
  return locales[fullLocale]?.vstFormat;
};

export function getVstuiLocaleFromFullLocale(vstLocale) {
  return locales[vstLocale]?.vstuiFormat;
}

export const getLocaleLabel = (fullLocale: string) => {
  return locales[fullLocale]?.label;
};

export const getLanguagePrefix = (locale) => {
  return locale.split("-")[0];
};

const convertToFullIfDefined = (vstValue) => {
  return vstValue ? getFullLocaleFromVst(vstValue) : null;
};

export const getBestLocale = ({ userLocale, brandLocale, queryLocale }) => {
  return (
    convertToFullIfDefined(queryLocale) ||
    convertToFullIfDefined(userLocale) ||
    convertToFullIfDefined(brandLocale) ||
    (isSupported(window.navigator.language) && window.navigator.language) ||
    "en-US"
  );
};
